import { AppRoutes } from '../../../../shared/lib/api-constant';
//import { ToasterSeverity, DialogService, BDPAuthService, UserSettingsService } from '../../../../shared/service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { DialogService } from '../../../../shared/service/dialog/dialog.service';
import { MessageService } from 'primeng/api';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private messageService: MessageService,
   // private userSettingsService: UserSettingsService,
    private authService: AuthService,
    public dialogService: DialogService) {

  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
    },
      (err: HttpErrorResponse) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 403: {
              if(err?.url?.includes('get-user-config') || err?.url?.includes('companies')) {
              this.router.navigate([AppRoutes.AuthAbstract.MAINTENANCE]);
              }
              throw new Error('You are not authorized to perform this operation!');
              break;
            }
            case 401: {
              this.authService.logout();
              throw new Error('Your Session has expired, please log in again.');
              
              break;
            }
            case 404: {
              console.log(err);
              break;
            }
            case 503: {
              this.router.navigate([AppRoutes.AuthAbstract.MAINTENANCE]);
              console.log(err);
              break;
            }
            case 417: {
              this.messageService.add({
                severity: "error",
                life: 10000,
                summary: 'Error Message',
                detail: err.error.data
              });
              console.log(err);
              break;
            }
            case 0: {
              this.pageBreakRedirect(err);
              break;
            }
          }
        }
      })
    );
  }

  private pageBreakRedirect(err:any) {
    console.log(err);
    if (err.url.includes(environment.baseurl)) {
      // if (this.bdpAuthService.token)
      //   this.router.navigate([AppRoutes.UserFull.PAGE_BREAK]);
      // else
      this.router.navigate([AppRoutes.AuthAbstract.PAGE_BREAK]);
    }
    else {
      throw err;
    }
  }

}
